import { useEffect, useState, useRef } from 'react'
import { UIMessage } from 'ai'

export function useAutoScroll<T extends HTMLElement>(
  messages: UIMessage[],
  isSubmitting: boolean
) {
  const containerRef = useRef<T>(null)
  const endRef = useRef<T>(null)
  const [userHasScrolled, setUserHasScrolled] = useState(false)

  useEffect(() => {
    const end = endRef.current
    if (end) {
      end.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleScroll = () => {
      const distanceFromBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight
      const isAtBottom = distanceFromBottom < 50
      setUserHasScrolled(!isAtBottom)
    }

    container.addEventListener('scroll', handleScroll)
    return () => {
      container.removeEventListener('scroll', handleScroll)
    }
  }, [containerRef])

  useEffect(() => {
    if (endRef.current && !userHasScrolled) {
      endRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [messages, endRef, userHasScrolled])

  const scrollToBottom = () => {
    setUserHasScrolled(false)
    setTimeout(() => {
      if (endRef.current) {
        endRef.current.scrollIntoView({ behavior: 'smooth' })
      }
    }, 100)
  }

  useEffect(() => {
    if (isSubmitting) {
      scrollToBottom()
    }
  }, [isSubmitting])

  return {
    messagesContainerRef: containerRef,
    messagesEndRef: endRef,
    scrollToBottom
  }
} 